var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1317_13233)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 11.5,
    stroke: "#E4E7EC",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3909 31.0143C28.8197 32.6147 27.8699 34.2597 26.2695 34.6885C24.6691 35.1174 23.0241 34.1676 22.5953 32.5672M24.8914 18.7404C25.1956 18.1931 25.2958 17.5316 25.121 16.879C24.7636 15.5453 23.3928 14.7538 22.0591 15.1112C20.7254 15.4686 19.934 16.8394 20.2913 18.1731C20.4662 18.8257 20.8837 19.3484 21.4208 19.6703M30.2358 22.4448C29.8788 21.1127 28.9259 19.9987 27.5866 19.348C26.2474 18.6972 24.6314 18.563 23.0944 18.9749C21.5573 19.3868 20.225 20.3109 19.3905 21.5441C18.556 22.7773 18.2877 24.2185 18.6447 25.5506C19.2352 27.7547 19.1206 29.5131 18.7476 30.8492C18.3225 32.3721 18.11 33.1335 18.1674 33.2864C18.2331 33.4613 18.2806 33.5093 18.4549 33.5768C18.6072 33.6358 19.2469 33.4644 20.5265 33.1216L32.3915 29.9423C33.6711 29.5995 34.3109 29.428 34.4132 29.3008C34.5304 29.1552 34.5475 29.0899 34.517 28.9055C34.4902 28.7444 33.9255 28.1913 32.7959 27.085C31.8049 26.1143 30.8264 24.6489 30.2358 22.4448Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1317_13233",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1317_13233"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1317_13233",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.e0df4a7a4210bff325f107d36c942811.svg";
export { ForwardRef as ReactComponent };